import { request } from "../request";
// 获取已评价列表
export const getEvaluatedList = (params) =>
  request(`/v1/course/comment/list`, "get", { params });
// 获取未评价列表
export const getUnEvaluatedList = (params) =>
  request(`/v1/course/comment/awaitList`, "get", { params });
